// Table Component
// Handles the display of table data and table item selection.
// 
// Props:
// showCheckboxes - enables checkbox visibility and automatically selectedItem management.
// hiddenColumns - an array containing column names (or data key strings) to hide from view.
// selectedItems - array containing selected items, used to pass the selected items out of the Table and into parent components.
// NOTICE: In order for the selectedItems prop to work the table data requires the uniqued id of an object to be passed or else the items in the selectedItems array will be overwritten
// data - array containing objects to be displayed in the table, the keys will become headers, with each object values on the subsequent rows.
// preRenderCallbacks - an object containing key-value pairs where the key corresponds to a column key in the data, 
//    and the value is a callback function to customize rendering for that column's values.
//    (see preRenderLinks() in QuizManager.js)
// 
// Comment last edited on 3/21/2024 by Riley Housden

import React, {useEffect, useState} from "react";
import TableItem from "./TableItem"
import Table from 'react-bootstrap/Table';
import { readQuizzes, deleteQuiz} from "../control/QuizData.js";



// Represents a table component that handles the display of table data and item selection.
function DataTable(props) {
  const [quizzes, setQuizzes] = useState([]);

  //function to fetch quizzes from database
  const fetchQuizzes = async() => {
    const fetchedData = await readQuizzes();
    setQuizzes(fetchedData);
  };
  //function to handle quiz deletion
  const handleDeleteQuiz = async (quizId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this quiz?");
    if(confirmDelete) {
      //Delete the quiz from database
      await deleteQuiz(quizId);
      //Fetch updated quizzes after deletion
      fetchQuizzes();
    }
  };
  useEffect(()=> {
    fetchQuizzes();
  }, []);

  function buildTableHeader() {
    const keys = Object.keys(props.data[0] || {});  // uses the keys in the first data item to build the headers
    if (props.showCheckboxes) {  // add a header for checkboxes if enabled
      keys.push("✓")
    }
    return (
      <tr>
        {keys.filter((key) => !props.hiddenColumns.includes(key))   // skip over hidden columns
          .map((key) => <th className="greenHeader" key={key}>{key}</th>)}
          {props.handleDelete ? <th className="greenHeader">Action</th> : null} {/* Action column for delete buttons */}
      </tr>
    );
  }

  function buildTableRows() {
    // creates TableItems containing the data for each item given in the table's data prop array.
    return props.data.map((item) => (
      
        <TableItem key={item.id} data={item}  hiddenColumns={props.hiddenColumns} selectedItemCallback={props.selectedItemCallback} preRenderCallbacks={props.preRenderCallbacks} handleDelete={props.handleDelete}></TableItem>
      ));
  }

  function selectedItemCallback(data) {
    // handles adding/removing items to the selectedItems property through a callback passed to TableItems - RH
    if (Object.keys(props.selectedItems).includes(data.id)) {
      delete props.selectedItems[data.id];
    } else {
      props.selectedItems[data.id] = data;
    }
  }

  return (
    <div>
      {/* <table border={"1"} className="QuizTable"> */}
      <Table striped bordered responsive>
        <thead>{buildTableHeader()}</thead>
        <tbody>{buildTableRows()}</tbody>
      </Table>
    </div>
  );
};

DataTable.defaultProps = {
  showCheckboxes: false,
  hiddenColumns: [],
  selectedItems: [],
  data: [],
  preRenderCallbacks: {},
  handleDelete: undefined
}

export default DataTable;
